import { render } from "./TvmSlideOutResearchModels.vue?vue&type=template&id=219df700&scoped=true"
import script from "./TvmSlideOutResearchModels.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutResearchModels.vue?vue&type=script&lang=js"

import "./TvmSlideOutResearchModels.vue?vue&type=style&index=0&id=219df700&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219df700"],['__file',"src/Components/ChatWidget/SlideOutPanel/TvmSlideOutResearchModels/TvmSlideOutResearchModels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "219df700"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('219df700', __exports__)) {
    api.reload('219df700', __exports__)
  }
  
  module.hot.accept("./TvmSlideOutResearchModels.vue?vue&type=template&id=219df700&scoped=true", () => {
    api.rerender('219df700', render)
  })

}


export default __exports__